import { ICombinedUserData } from 'lib/context';

export const calculateOpacityFromHexAlpha = (value?: string) => {
  if (!value) {
    return null;
  }
  const escapedHex = value.replace('#', '');
  const opacityString = escapedHex.substring(
    escapedHex.length - 2,
    escapedHex.length
  );
  return Math.ceil(((parseInt(opacityString, 16) / 255) * 1000) / 10);
};

export const userHasLandingPageDesignAccess = (user: ICombinedUserData) => {
  return !!Number(user.landingPageDesignAdministration);
};
